// modules
import React, { Component } from 'react';
import withStyles from "@material-ui/core/styles/withStyles";
import { connect } from 'react-redux'
// src
// import { devLog } from './constants'
import FixBox from '../components/FixBox'
import AreaTable from '../components/AreaTable'
// import AreaMap from '../components/AreaMap'
import DeliveryDateCalendar from '../components/DeliveryDateCalendar'
import SelectSpeedType from '../components/SelectSpeedType'
import SelectHouseType from '../components/SelectHouseType'
import SelectPaperSizeType from '../components/SelectPaperSizeType'
import SelectFoldingType from '../components/SelectFoldingType'
import SelectPrintNumType from '../components/SelectPrintNumType'
import SelectPaperQualityType from '../components/SelectPaperQualityType'
import SelectColorType from '../components/SelectColorType'
import SelectGapType from '../components/SelectGapType'
import SelectRequestDesignType from '../components/SelectRequestDesignType'

import { getInitialOptions } from '../actions/options'

const styles = {
}

class SetPackFlyer extends Component {
    componentDidMount() {
        this.props.getInitialOptions()
    }
    render() {
        // const { classes } = this.props;
        return (
            <div className="ViewSetPackFlyer">
                <div className="rightCol">
                    <FixBox />
                </div>
                <div className="leftCol">
                    <h2 className="productTitle">チラシ印刷＋ポスティング</h2>
                    <AreaTable />
                    <DeliveryDateCalendar />
                    <table className="optionTable">
                        <tbody>
                            <tr>
                                <th><span>配布期間</span></th>
                                <td>
                                    <span>
                                        <SelectSpeedType />
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <th><span>住居指定</span></th>
                                <td>
                                    <span>
                                        <SelectHouseType />
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <th><span>用紙サイズ</span></th>
                                <td>
                                    <span>
                                        <SelectPaperSizeType />
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <th><span>印刷部数</span></th>
                                <td>
                                    <span>
                                        <SelectPrintNumType />
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <th><span>印刷用紙・厚さ</span></th>
                                <td>
                                    <span>
                                        <SelectPaperQualityType />
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <th><span>印刷色数</span></th>
                                <td>
                                    <span>
                                        <SelectColorType />
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <th><span>折り加工</span></th>
                                <td>
                                    <span>
                                        <SelectFoldingType />
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <th><span>印刷端数</span></th>
                                <td>
                                    <span>
                                        <SelectGapType />
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <th><span>デザイン制作</span></th>
                                <td>
                                    <span>
                                        <SelectRequestDesignType />
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                {/* <button onClick={this.props.getInitialOptions}>TEST</button> */}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    // member: state.members.one,
})

const mapDispatchToProps = dispatch => ({
    getInitialOptions: () => dispatch(getInitialOptions()),
})


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(SetPackFlyer));



// WEBPACK FOOTER //
// ./src/views/SetPackFlyer.js